/* ============================================================
   PDP — cor do texto (e dos icones) sobre imagem de fundo.

   Para cada texto/icone que fica em cima de uma imagem, olha os pixels
   da area da imagem logo atras dele e troca a cor: cor escura da marca
   quando ela fica legivel em mais pixels que o claro; no empate (ex.:
   fundo laranja) nao mexe, vale a cor configurada no tema. Texto grande
   e icones usam o laranja da marca se ele passar em >= 90% do fundo;
   senao, marrom. Icones sao recoloridos pelo canal alfa (canvas).

   - A analise e feita por elemento e com a imagem que o navegador esta
     exibindo agora (desktop ou mobile), entao cada viewport tem a sua.
   - Considera camadas translucidas entre a imagem e o texto (ex.: os
     "chips" de beneficios, rgba(240,240,240,.44)), compondo a cor delas
     sobre a media da imagem antes de medir o brilho.
   - Nao enxerga gradientes CSS (background-image) nem sombras.
   - Sem leitura possivel da imagem (CORS/rede): nada muda.
   - Desligar num elemento: data-contraste="off" nele ou num ancestral.

   Escopo (SECOES): so as secoes da PDP listadas abaixo, pela chave da
   secao no templates/product.json (o id do DOM termina em __<chave>).
   Para incluir outra secao, acrescentar a chave aqui.
   Carregado so no template de produto (layout/theme.liquid).
   ============================================================ */
(function () {
  'use strict';

  var SECOES = [
    'custom_section_JNGUt7', /* Banner PDP visao-geral */
    'custom_section_caRGLD' /* Banner Divididos PDP */
  ];

  /* Cores da marca. Fundo claro: laranja nos textos grandes e icones (quando
     fica legivel em quase todo o fundo), marrom no resto. */
  var MARROM = '#362017';
  var LARANJA = '#ec6731';
  var LUM_CLARO = 1; /* #ffffff */
  var LUM_MARROM = 0.0188; /* luminancia relativa de #362017 */
  var LUM_LARANJA = 0.288; /* luminancia relativa de #ec6731 */
  var MIN_CONTRASTE = 3; /* WCAG, texto grande / graficos */
  var FRACAO_LARANJA = 0.9; /* laranja so se legivel em >= 90% dos pixels */
  var GRANDE_PX = 24; /* texto "grande": >= 24px, ou >= 19px em negrito */
  var GRANDE_NEGRITO_PX = 19;
  var AMOSTRA = 320; /* largura maxima do canvas de leitura, em px */
  var MARGEM = 6; /* folga em volta do elemento, em px de tela */
  var ATTR = 'data-contraste-pdp';

  var cache = {}; /* src -> Promise de { data, w, h, nw, nh } */

  var LIN = [];
  for (var i = 0; i < 256; i++) {
    var c = i / 255;
    LIN[i] = c <= 0.04045 ? c / 12.92 : Math.pow((c + 0.055) / 1.055, 2.4);
  }

  function carregar(src) {
    if (cache[src]) return cache[src];
    cache[src] = new Promise(function (resolve, reject) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var nw = im.naturalWidth;
          var nh = im.naturalHeight;
          var w = Math.min(AMOSTRA, nw);
          var h = Math.max(1, Math.round(nh * (w / nw)));
          var cv = document.createElement('canvas');
          cv.width = w;
          cv.height = h;
          var ctx = cv.getContext('2d', { willReadFrequently: true });
          ctx.drawImage(im, 0, 0, w, h);
          resolve({ data: ctx.getImageData(0, 0, w, h).data, w: w, h: h, nw: nw, nh: nh });
        } catch (e) {
          reject(e); /* canvas "tainted" */
        }
      };
      im.onerror = reject;
      im.src = src;
    });
    return cache[src];
  }

  /* Retangulo (tela) do elemento -> retangulo na amostra. */
  function regiao(img, caixa, amostra) {
    var ir = img.getBoundingClientRect();
    if (!ir.width || !ir.height || !caixa.width || !caixa.height) return null;

    var fit = getComputedStyle(img).objectFit;
    var sx = ir.width / amostra.nw;
    var sy = ir.height / amostra.nh;
    var ox = 0;
    var oy = 0;
    if (fit === 'cover' || fit === 'contain') {
      var s = fit === 'cover' ? Math.max(sx, sy) : Math.min(sx, sy);
      sx = sy = s;
      ox = (ir.width - amostra.nw * s) / 2; /* object-position: centro */
      oy = (ir.height - amostra.nh * s) / 2;
    }

    var k = amostra.w / amostra.nw;
    var x0 = Math.max(0, Math.floor(((caixa.left - MARGEM - ir.left - ox) / sx) * k));
    var x1 = Math.min(amostra.w, Math.ceil(((caixa.right + MARGEM - ir.left - ox) / sx) * k));
    var y0 = Math.max(0, Math.floor(((caixa.top - MARGEM - ir.top - oy) / sy) * k));
    var y1 = Math.min(amostra.h, Math.ceil(((caixa.bottom + MARGEM - ir.top - oy) / sy) * k));
    if (x1 <= x0 || y1 <= y0) return null;
    return { x0: x0, y0: y0, x1: x1, y1: y1 };
  }

  function lerRgba(css) {
    var m = css.match(/rgba?\(([^)]+)\)/);
    if (!m) return null;
    var p = m[1]
      .split(/[,\s/]+/)
      .filter(Boolean)
      .map(parseFloat);
    if (p.length < 3) return null;
    return { r: p[0], g: p[1], b: p[2], a: p.length > 3 ? p[3] : 1 };
  }

  /* Fundos translucidos entre o bloco da imagem (exclusive) e o elemento
     (inclusive), de fora para dentro. */
  function camadasDe(el, bloco) {
    var camadas = [];
    for (var n = el; n && n !== bloco; n = n.parentElement) {
      var cor = lerRgba(getComputedStyle(n).backgroundColor);
      if (cor && cor.a > 0) camadas.unshift(cor);
    }
    return camadas;
  }

  function contraste(l1, l2) {
    var a = Math.max(l1, l2);
    var b = Math.min(l1, l2);
    return (a + 0.05) / (b + 0.05);
  }

  /* Em que fracao dos pixels de tras do elemento cada cor fica legivel
     (contraste >= MIN_CONTRASTE)? O marrom so ganha se for estritamente
     mais legivel que o claro; empate mantem a cor do tema. Medir por
     pixel (e nao pela media) evita errar quando o fundo mistura areas
     claras e escuras, como cabelo escuro sobre um fundo claro. */
  function decidirCor(amostra, r, camadas) {
    var okClaro = 0;
    var okMarrom = 0;
    var okLaranja = 0;
    var n = 0;
    for (var y = r.y0; y < r.y1; y++) {
      for (var x = r.x0; x < r.x1; x++) {
        var p = (y * amostra.w + x) * 4;
        var a = amostra.data[p + 3] / 255;
        var R = amostra.data[p] * a + 255 * (1 - a);
        var G = amostra.data[p + 1] * a + 255 * (1 - a);
        var B = amostra.data[p + 2] * a + 255 * (1 - a);
        for (var c = 0; c < camadas.length; c++) {
          var cm = camadas[c];
          R = cm.r * cm.a + R * (1 - cm.a);
          G = cm.g * cm.a + G * (1 - cm.a);
          B = cm.b * cm.a + B * (1 - cm.a);
        }
        var l = luminancia([R, G, B]);
        if (contraste(LUM_CLARO, l) >= MIN_CONTRASTE) okClaro++;
        if (contraste(LUM_MARROM, l) >= MIN_CONTRASTE) okMarrom++;
        if (contraste(LUM_LARANJA, l) >= MIN_CONTRASTE) okLaranja++;
        n++;
      }
    }
    if (!n) return null;
    if (okMarrom <= okClaro) return { cor: null }; /* mantem a cor do tema */
    return { cor: MARROM, laranjaOk: okLaranja / n >= FRACAO_LARANJA };
  }

  function luminancia(rgb) {
    function f(v) {
      return LIN[Math.max(0, Math.min(255, Math.round(v)))];
    }
    return 0.2126 * f(rgb[0]) + 0.7152 * f(rgb[1]) + 0.0722 * f(rgb[2]);
  }

  function caixaDe(el) {
    if (el.classList.contains('text-block')) {
      var range = document.createRange();
      range.selectNodeContents(el);
      return range.getBoundingClientRect();
    }
    return el.getBoundingClientRect();
  }

  function ehGrande(el) {
    var cs = getComputedStyle(el);
    var px = parseFloat(cs.fontSize) || 0;
    var peso = parseInt(cs.fontWeight, 10) || 400;
    return px >= GRANDE_PX || (px >= GRANDE_NEGRITO_PX && peso >= 700);
  }

  var iconesCache = {}; /* src|cor -> Promise<dataURL> */

  /* Recolore um icone monocromatico: mantem o canal alfa, troca a cor. */
  function recolorir(src, cor) {
    var chave = src + '|' + cor;
    if (iconesCache[chave]) return iconesCache[chave];
    iconesCache[chave] = new Promise(function (resolve, reject) {
      var im = new Image();
      im.crossOrigin = 'anonymous';
      im.onload = function () {
        try {
          var w = im.naturalWidth || 128;
          var h = im.naturalHeight || 128;
          var k = Math.min(1, 512 / Math.max(w, h));
          var cv = document.createElement('canvas');
          cv.width = Math.max(1, Math.round(w * k));
          cv.height = Math.max(1, Math.round(h * k));
          var ctx = cv.getContext('2d');
          ctx.drawImage(im, 0, 0, cv.width, cv.height);
          ctx.globalCompositeOperation = 'source-in';
          ctx.fillStyle = cor;
          ctx.fillRect(0, 0, cv.width, cv.height);
          resolve(cv.toDataURL('image/png'));
        } catch (e) {
          reject(e);
        }
      };
      im.onerror = reject;
      im.src = src;
    });
    return iconesCache[chave];
  }

  function aplicarIcone(el, cor) {
    if (!el.hasAttribute('data-contraste-orig')) {
      el.setAttribute('data-contraste-orig', el.currentSrc || el.src);
      el.setAttribute('data-contraste-orig-srcset', el.getAttribute('srcset') || '');
    }
    var orig = el.getAttribute('data-contraste-orig');
    if (!cor) {
      if (el.getAttribute('src') !== orig) {
        el.setAttribute('src', orig);
        var ss = el.getAttribute('data-contraste-orig-srcset');
        if (ss) el.setAttribute('srcset', ss);
      }
      el.style.removeProperty('filter');
      return;
    }
    recolorir(orig, cor)
      .then(function (url) {
        el.removeAttribute('srcset');
        el.setAttribute('src', url);
        el.style.removeProperty('filter');
      })
      .catch(function () {
        /* sem leitura do icone: cai para preto, que ao menos le */
        el.style.setProperty('filter', 'brightness(0)', 'important');
      });
  }

  function aplicarTexto(el, cor) {
    var alvos = [el].concat(Array.prototype.slice.call(el.querySelectorAll('*')));
    alvos.forEach(function (a) {
      if (cor) a.style.setProperty('color', cor, 'important');
      else a.style.removeProperty('color');
    });
  }

  function aplicar(el, decisao) {
    var ehIcone = el.tagName === 'IMG';
    var cor = decisao.cor;
    if (cor && decisao.laranjaOk && (ehIcone || ehGrande(el))) cor = LARANJA;
    if (ehIcone) aplicarIcone(el, cor);
    else aplicarTexto(el, cor);
  }

  function ajustarBloco(bloco) {
    var img = bloco.querySelector(':scope > picture img, :scope > a > picture img');
    if (!img) return;
    var src = img.currentSrc || img.src;
    if (!src) return;

    var alvos = bloco.querySelectorAll('.image-block__content-wrapper .text-block, .image-block__content-wrapper img');
    if (!alvos.length) return;

    carregar(src)
      .then(function (amostra) {
        Array.prototype.forEach.call(alvos, function (el) {
          if (el.closest('[data-contraste="off"]')) return;
          var r = regiao(img, caixaDe(el), amostra);
          if (!r) return; /* oculto neste viewport */
          var decisao = decidirCor(amostra, r, camadasDe(el, bloco));
          if (decisao === null) return;
          aplicar(el, decisao);
        });
      })
      .catch(function () {
        /* sem leitura possivel: mantem as cores do tema */
      });
  }

  function iniciar() {
    var blocos = [];
    SECOES.forEach(function (chave) {
      var secoes = document.querySelectorAll('[id$="__' + chave + '"]');
      Array.prototype.forEach.call(secoes, function (secao) {
        Array.prototype.forEach.call(secao.querySelectorAll('.image-block'), function (b) {
          if (b.querySelector('.image-block__content-wrapper')) blocos.push(b);
        });
      });
    });

    blocos.forEach(function (bloco) {
      if (bloco.hasAttribute(ATTR)) return;
      bloco.setAttribute(ATTR, '');

      var timer = null;
      function agendar() {
        clearTimeout(timer);
        timer = setTimeout(function () {
          ajustarBloco(bloco);
        }, 150);
      }

      ajustarBloco(bloco);
      var img = bloco.querySelector('picture img');
      if (img) img.addEventListener('load', agendar);
      window.addEventListener('resize', agendar);
      if (document.fonts && document.fonts.ready) document.fonts.ready.then(agendar);
    });
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', iniciar);
  else iniciar();
})();
